import React from 'react';

interface ImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
  sizes?: string;
  loading?: 'lazy' | 'eager';
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
}

/**
 * Custom Image component that replaces Next.js Image component
 * for use in non-Next.js React applications
 */
const Image: React.FC<ImageProps> = ({
  src,
  alt,
  width,
  height,
  className = '',
  priority = false,
  sizes,
  loading = 'lazy',
  objectFit = 'cover',
}) => {
  // Only use eager loading if priority is true
  const loadingAttribute = priority ? 'eager' : loading;
  
  // Set inline styles based on props
  const style: React.CSSProperties = {};
  
  if (objectFit) {
    style.objectFit = objectFit;
  }
  
  if (width) {
    style.width = `${width}px`;
  }
  
  if (height) {
    style.height = `${height}px`;
  }
  
  return (
    <img
      src={src}
      alt={alt}
      loading={loadingAttribute}
      sizes={sizes}
      style={style}
      className={className}
    />
  );
};

export default Image; 